import React, { useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import useCustomAddressDetail from "src/hooks/user/customer/useCustomAddressDetail";
import { useFormContext } from "react-hook-form";
import { getAddressPath } from "src/utils/address";

const AddressList = ({ onChangeAddressMode }) => {
  const form = useFormContext();
  const customer = form?.watch(`customer`);
  const { data: customerAddress } = useCustomAddressDetail(customer?._id);

  const handleChangeAddressMode = () => {
    onChangeAddressMode(true);
  };

  useEffect(() => {
    form.setValue(
      "recipient",
      customerAddress?.data?.find((v) => v?.isDefault === true),
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerAddress]);

  return (
    <>
      {customerAddress?.data?.map((v) => {
        return (
          v?.isDefault && (
            <Box
              key={v?._id}
              sx={{
                background: "var(--light-grey)",
                flex: 1,
                borderRadius: "6px",
                p: "12px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  variant="body1"
                  fontWeight="bold"
                >
                  Địa chỉ cụ thể
                </Typography>
                <Button
                  onClick={handleChangeAddressMode}
                  variant="outlined"
                  sx={{
                    height: "22px",
                    fontSize: "12px",
                    p: 0,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  Thay đổi
                </Button>
              </Box>
              <Typography variant="body2">{v?.phone ?? "N/A"}</Typography>
              <Typography variant="body2">{v?.detailAddress ?? "N/A"}</Typography>
              <Typography variant="body2">{getAddressPath(v?.ward)}</Typography>
            </Box>
          )
        );
      })}

      {(!customerAddress?.data?.length || !customerAddress?.data?.find((v) => v?.isDefault === true)) && (
        <Box
          sx={{
            width: "50%",
            background: "var(--light-grey)",
            borderRadius: "6px",
            p: "12px",
          }}
        >
          <Typography
            variant="body1"
            fontWeight="bold"
          >
            Địa chỉ cụ thể
          </Typography>
          <Typography
            variant="body2"
            sx={{ fontStyle: "italic", mt: "6px" }}
          >
            Chưa thiết lập địa chỉ
          </Typography>
          <Button
            onClick={handleChangeAddressMode}
            size="small"
            sx={{ mt: "6px" }}
          >
            Thiết lập địa chỉ
          </Button>
        </Box>
      )}
    </>
  );
};

export default AddressList;
